import { L10n } from '@flippingbook/web.react-kit/dist/L10n';
import type { To } from 'react-router-dom';

import { loc } from '@/localization';
import { ErrorBox } from '@/site/components/ErrorBox';
import { Link } from '@/site/components/Link';

import { e } from './style.css';

export function ErrorBoxes(props: ErrorBoxes.Props) {
    const { hasFacebookEmailError, hasPolicyError, registrationUrl, resetPolicyError, selectSamlUrl } = props;

    return (
        <>
            {hasFacebookEmailError && (
                <ErrorBox className={e.errorBox}>
                    <L10n
                        text={loc.Login.SignupLoginErrorFacebookNoEmail}
                        replaces={[
                            [
                                '{doRegister}',
                                <Link
                                    className={e.boldLink}
                                    to={registrationUrl}
                                    onClick={resetPolicyError}
                                >
                                    {loc.Login.DoSignUp.toLowerCase()}
                                </Link>,
                            ],
                        ]}
                    />
                </ErrorBox>
            )}
            {hasPolicyError && (
                <ErrorBox className={e.errorBox}>
                    <L10n
                        text={loc.Login.SignupLoginErrorThirdPartyDisabled}
                        replaces={[
                            [
                                '{doSsoLogin}',
                                <Link
                                    className={e.boldLink}
                                    to={selectSamlUrl}
                                >
                                    {loc.Login.DoSsoLogin}
                                </Link>,
                            ],
                        ]}
                    />
                </ErrorBox>
            )}
        </>
    );
}

export namespace ErrorBoxes {
    export interface Props {
        hasFacebookEmailError: boolean;
        hasPolicyError: boolean;
        registrationUrl: To;
        selectSamlUrl: To;
        resetPolicyError: () => void;
    }
}
